import {
    GET_TRANSACTION_DATA_FAILED, GET_TRANSACTION_DATA_LOADING,
    GET_TRANSACTION_DATA_REMOVE, GET_TRANSACTION_DATA_SUCCESS
} from "../types";

const initialState = {
    loading: false,
    error: null,
    status: null,
    gatewayTransaction: null,
    payMethod: null,
    request: null,
};

export const paymentGatewayTrxReducer = (
    state = initialState,
    action: { type: any; loading: any; payload: any; status: any; error: any, request: any, payMethod: any }
) => {
    switch (action.type) {
        case GET_TRANSACTION_DATA_LOADING:
            return {
                ...state,
                loading: true,
            };
        case GET_TRANSACTION_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                gatewayTransaction: action.payload,
                status: action.status,
                error: null,
                request: action.request,
                payMethod: action.payMethod
            };
        case GET_TRANSACTION_DATA_FAILED:
            return {
                ...state,
                loading: false,
                gatewayTransaction: null,
                status: action.status,
                error: action.error,
                request: action.request,
                payMethod: action.payMethod,
            };
        case GET_TRANSACTION_DATA_REMOVE:
            return {
                loading: false,
                error: null,
                status: null,
                gatewayTransaction: null,
                payMethod: null,
                request: null,
            }

        default:
            return state;
    }
};




